interface Props {
  id: string;
  fieldtype: string;
  error?: string;
  onChange: (id: string, name: string, value: string, rules: any[], label: string, fieldtype: string) => void;
  isRequired?: boolean;
  label: string;
  rules?: any[];
  disabled: boolean;
  value: string;
}

export default function TextArea({
  id,
  isRequired,
  rules = [],
  error,
  onChange,
  disabled,
  value,
  label,
  fieldtype,
}: Props) {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value: inputValue } = event.target;
    onChange(id, name, inputValue, rules, label, fieldtype);
  };
  fieldtype = "TextArea";
  if (isRequired) {
    rules = [...rules, "required"];
  }

  return (
    <div className="bu-flex bu-flex-col">
      <label htmlFor={id} className="bu-m-2 bu-text-foreground">
        {label} {isRequired && <span className="bu-text-red">*</span>}
      </label>
      <textarea
        id={id}
        name={id}
        required={isRequired}
        rows={5}
        value={value}
        onChange={handleChange}
        className={`bu-border bu-rounded bu-p-2 bu-text-black ${error ? "bu-border-red/80" : ""}`}
        aria-required={isRequired}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        disabled={disabled}
      />

      {error && (
        <div id={`${id}-error`} className="bu-capitalize-first bu-text-red">
          {error}
        </div>
      )}
    </div>
  );
}
